import { render, staticRenderFns } from "./YoungsTable.vue?vue&type=template&id=23004ae0&scoped=true"
import script from "./YoungsTable.vue?vue&type=script&lang=js"
export * from "./YoungsTable.vue?vue&type=script&lang=js"
import style0 from "./YoungsTable.vue?vue&type=style&index=0&id=23004ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23004ae0",
  null
  
)

export default component.exports